<!--  -->
<template>
<div>
   <van-swipe-cell :class="{ 'disabled': disabled }">
   <!-- 单个课程 -->
     <div :class="['aSingleCourse',{failureUi:doNot}]">
      <div class="courseTitle">
        <img v-if="doNot" :src="notCk" alt="" >
        <img  v-else :src="checkItem ? checked : noCheck" alt="" @click.stop="selectItem(courseInfo)">
        <h3>{{courseInfo.cartProductItem.name }}</h3>
      </div>

      <div :class="['courseMation',{addcourseMation:courseInfo.cartProductItem.isDefault===1}]">
        <template v-if="courseInfo.cartProductItem.isDefault===0">
          <div class="courseType" @click.stop="chooseType(courseInfo)">
            <span> {{String(showType)}}</span>
            <img src="@/assets/img/car/icon01.png" alt=""></div>
         </template>
        <div class="coursePrice" v-if="courseInfo.cartProductItem.isAccommodation!=1"><span>¥</span>{{courseInfo.cartProductItem.skuPrice}}</div>
      </div>
      </div>
      <template #right>
        <div class="delete"  @click="deleteGood(courseInfo.cartId)">
          <div>
             <img
            src="@/assets/img/car/delete.png"
            class="img"
          />
          <span>删除</span>
          </div>
        </div>
        </template>
     </van-swipe-cell>

</div>

</template>

<script>
// <!-- isDefault  1 单品 0 非单品 -->
export default {
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
    // doNot为true 展示失效商品UI
    doNot: {
      type: Boolean,
      default: false,
    },

    checkList: {
      type: Array,
      default: () => {},

    },
    disabled: {
    type: Boolean,
    default: false
  }
  },
  data() {
    return {
      checked: require('@/assets/img/car/cked.png'),
      noCheck: require('@/assets/img/car/nck.png'),
      notCk: require('@/assets/img/car/notck.png'), // 不可操作
      showType: '', // 当前规格,

    };
  },

  components: {

  },
  watch: {
    courseInfo: {
      handler(val) {
        this.showType = JSON.parse(val.cartProductItem.specJson || '[]')?.map((item) => item.value);
      },
      immediate: true,
    },

  },
  computed: {
    checkItem() {
      return this.checkList.filter((item) => item.cartId === this.courseInfo.cartId).length !== 0;
    },

  },

  mounted() {},

  created() {
  },

  methods: {
    selectItem(data) {
      if(this.disabled){
        this.$toast('套餐和单品不可同时选择');
        return
      }
      console.log(this.checkItem);
      // 选中
      if (!this.checkItem) {
        this.$emit('checkOneCourse', data);
      } else {
        this.$emit('cleanCourse', data);
      }
    },
    chooseType(data) {
      this.$emit('chooseType', data);
    },
    deleteGood(cartId) {
      this.$emit('deleteGood', cartId);
    },

  },

};
</script>
<style lang="scss" scoped>
 ::v-deep .van-swipe-cell.disabled{
      opacity: 0.5;
      filter: grayscale(1);
    }
    .aSingleCourse{
      box-sizing: border-box;
      margin-bottom: 24px;
      margin-left: 40px;
      padding:40px 32px 40px 24px;
      background: #fff;
      border-radius: 16px;
      .courseTitle{
        display: flex;
        align-items: center;
        margin-bottom: 26px;
        img{
          display: block;
          width: 48px;
          height: 48px;
          margin-right: 16px;
        }
        h3{
          width: 620px;
          overflow: hidden;
          color: #333;
          font-weight: 500;
          font-size: 32px;
          line-height: 44px;
          white-space: nowrap;
          text-overflow: ellipsis;

        }
      }

      .courseMation{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 65px;
        .courseType{
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 56px;
          padding-left:10px;
          background: #F9F9F9;
          border-radius: 7px;
          span{
            min-width: 30px;
            max-width: 270px;
            overflow: hidden;
            color: #999;
            font-weight: 400;
            font-size: 28px;
            line-height: 56px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          img{
            display: block;
            width: 48px;
            height: 48px;
          }

        }
        .coursePrice{
          color: #FF3938;
          font-weight: 500;
          font-size: 40px;
          line-height: 40px;
          span{
            font-size: 30px;
          }
        }

      }
      .addcourseMation{
         justify-content:flex-end;
      }

    }

    .delete{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 128px;
      height: 100%;
      background: #F84508;
      border-radius: 0 16px 16px 0;
      img{
        width: 48px;
        height: 48px;
      }
      span{
        display: block;
      color: #FFF;
      font-weight: 500;
      font-size: 28px;
      line-height: 40px;
      }
    }

   .failureUi{
      background: #F5F5F5;
      border: 2px solid #EEE;
       .courseTitle{
        h3{
         color: #787878;
        }
      }
      .courseMation{
        .courseType{
          color: #999;
        }
        .coursePrice{
        color: #999;
        }
      }

    }
</style>
